console.log('Vite ⚡️ Rails')
console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

console.log(import.meta.env.RAILS_ENV);
console.log(import.meta.env);

// Styles
import "~/stylesheets/index.scss";

// JS
import $ from "jquery";
Object.assign(window, { jQuery: $, $ });

// Import all of Bootstrap's JS (from bootstrap3-sass)
import "bootstrap3-sass/assets/javascripts/bootstrap.js";

// Import vendor files (legacy JS that depends on jQuery)
import "~/vendor";

// Import controllers (Stimulus)
import "~/controllers";

// Import accessibility utilities
import { Announcer } from "~/utils/announcer";
// Make available globally for other scripts
window.Announcer = Announcer;

// upgrade path:
// 	•	Phase 1: Use @rails/ujs via Vite, keep everything working.
// 	•	Phase 2: Add Turbo, migrate method: links to data: { turbo_method: ... } at your own pace.
import Rails from "@rails/ujs"
Rails.start()

// Load Rails libraries in Vite.
// import * as Turbo from "@hotwired/turbo";
// import * as ActiveStorage from "@rails/activestorage";
// import DirectUpload from "~/utils/direct_uploads";

// Turbo.start();
// Disable Turbo Drive (we only want Turbo Frames and Turbo Streams)
// Turbo.session.drive = false;
// Turbo.config.morph = false
// ActiveStorage.start();
// DirectUpload.start();

// initialize the page with Turbo
// window.addEventListener("turbo:load", (_event) => {
//   console.log("turbo:load");
//   initPage();
// });

// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// function initPage() {
//   // do global initialization here
// }